module.exports = require("./af-NA.d.ts");